"use client";

import { CreateOrUpdateCertificate } from "components/ui/v2/certificates/bundle/Certificates/Forms/CreateOrUpdateCertificate";
import { ICertificate } from "gql/Certificates/queries";
import type { ReactNode } from "react";
import { CERTIFICATE_FORM_ID } from "./CertificateCreateModalContentV2";

export interface CertificateUpdateModalContentV2Props {
  onClose: () => void;
  certificate: ICertificate;
  hideHeader?: boolean;
  hideFooter?: boolean;
  formId?: string;
  onFooterChange?: (footer: ReactNode) => void;
}

export function CertificateUpdateModalContentV2({
  onClose,
  certificate,
  hideHeader = true,
  hideFooter = false,
  formId = CERTIFICATE_FORM_ID,
  onFooterChange,
}: CertificateUpdateModalContentV2Props) {
  return (
    <CreateOrUpdateCertificate
      certificate={certificate}
      onClose={onClose}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      formId={formId}
      onFooterChange={onFooterChange}
    />
  );
}
